// extracted by mini-css-extract-plugin
module.exports = {"container":"Tabs_container__3-_Dp","content":"Tabs_content__spRCv","floatingPill":"Tabs_floatingPill__2Apro"};